import { render, staticRenderFns } from "./UserQuesColumn.vue?vue&type=template&id=527c29cd&scoped=true&"
import script from "./UserQuesColumn.vue?vue&type=script&lang=js&"
export * from "./UserQuesColumn.vue?vue&type=script&lang=js&"
import style0 from "./UserQuesColumn.vue?vue&type=style&index=0&id=527c29cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c29cd",
  null
  
)

export default component.exports